import Vue from "vue";
import VueRouter from "vue-router";
import PageNotFound from "./pages/PageNotFound.vue";
import Home from "./pages/Home.vue";
import ProductList from "./pages/ProductList.vue";
import Profile from "./pages/Profile.vue";
import ProductPage from "./pages/ProductPage.vue";
import PaymentSuccessPage from "./pages/PaymentSuccessPage.vue";
import PaymentFaliPage from "./pages/PaymentFaliPage.vue";
import TextPage from "./pages/TextPage.vue";
import Faq from "./pages/Faq.vue";
import PromtCreate from "./pages/PromtCreate.vue";
import SignIn from "./pages/SignIn.vue";
import SignUp from "./pages/SignUp.vue";

Vue.use(VueRouter);

export default new VueRouter({
  routes: [
    { path: "/", redirect: "/home" },
    {
      path: "/home",
      name: "Home",
      component: Home,
    },
    {
      path: "/product-list",
      name: "ProductList",
      component: ProductList,
    },
    {
      path: "/profile/:page",
      name: "Profile",
      component: Profile,
    },
    {
      path: "/products/:id",
      name: "ProductPage",
      component: ProductPage,
    },
    {
      path: "/success-payment",
      name: "PaymentSuccessPage",
      component: PaymentSuccessPage,
    },
    {
      path: "/fail-payment",
      name: "PaymentFaliPage",
      component: PaymentFaliPage,
    },
    {
      path: "/faq",
      name: "Faq",
      component: Faq,
    },
    {
      path: "/sign-in",
      name: "SignIn",
      component: SignIn,
    },
    {
      path: "/sign-up",
      name: "SignUp",
      component: SignUp,
    },

    {
      path: "/pages/:url",
      name: "TextPage",
      component: TextPage,
    },
    {
      path: "/promt-create/:id",
      name: "PromtCreate",
      component: PromtCreate,
    },

    {
      path: "*",
      name: "PageNotFound",
      component: PageNotFound,
      props: { title: "PageNotFound" },
    },
  ],
});
